import { useEffect, useRef, useState } from 'react';
import { s } from './Filter.styles';
import {
  BidStatusList,
  CourtList,
  FilterType,
  ItemStatusList,
  ProgressStatusList,
  PTypeItemStatusList,
  PTypeProgressStatusList,
  Region,
  RegionProps,
  SidoList,
} from '../FilterData';
import Select from 'react-select';
import RegionService from '../../../service/Region';
import List from '../../components/list/List';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/footer/Footer';
import LoanInfoService from '../../../service/LoanInfo';
import AddInterestItemModal from '../../components/modal/AddInterestItem';
import { isLogin } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';

type SortOption = { value: string; label: string };

interface EasyFilterProps {
  page: string;
}

const EasyFilter = ({ page }: EasyFilterProps) => {
  const { modalDispatch } = useModal();
  const [filters, setFilters] = useState<FilterType>({
    type: 'a',
    regionOrCourt: 'r',
    region: [] as Region[],
    court: '',
    year: '',
    caseNumber: '',
    itemStatus: [],
    multiItemStatus: [],
    appraisalPrice: { min: '', max: '' },
    minPrice: { min: '', max: '' },
    saleDate: { start: '', end: '' },
    approvalDate: { start: '', end: '' },
    buildingArea: { min: '', max: '' },
    landArea: { min: '', max: '' },
    bidStatus: '',
    progressStatus: '진행',
    useArea: [],
    multiUseArea: [],
    specialConditionViewOption: 'o',
    specialItemCondition: [],
    multiSpecialItemCondition: [],
    holdingCompany: [],
    multiHoldingCompany: [],
  });
  const [sido, setSido] = useState('');
  const [sigungu, setSigungu] = useState('');
  const [emd, setEmd] = useState('');
  const [sigunguList, setSigunguList] = useState<RegionProps[] | undefined>([]);
  const [emdList, setEmdList] = useState<RegionProps[] | undefined>([]);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState([]);
  const [sort, setSort] = useState<SortOption>({
    value: 'DA',
    label: '매각기일 빠른순',
  });
  const [loading, setLoading] = useState(false);
  const [showLikeModal, setShowLikeModal] = useState<boolean>(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const navigate = useNavigate();

  const param = new URLSearchParams(window.location.search);
  const options = param.get('options');
  const parsedFilters = JSON.parse(options?.replace(/'/g, '"') || '{}');

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '8px',
      border: 'none',
      height: '40px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      padding: 0,
      backgroundColor: '#F7F8FC',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      backgroundColor: state.isSelected ? '#e6e6e6' : provided.backgroundColor,
      color: state.isSelected ? '#000' : '#333',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      whiteSpace: 'nowrap',
    }),
  };

  const getRegion = async (code: string) => {
    try {
      const res = await RegionService.list(code);
      return res.data as RegionProps[];
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (sido !== '') {
      getRegion(sido).then((res) => setSigunguList(res));
    }
  }, [sido]);

  useEffect(() => {
    if (sigungu !== '') {
      getRegion(sigungu).then((res) => setEmdList(res));
    }
  }, [sigungu]);

  const sidoOptions = SidoList.map((sido) => ({
    value: sido.code,
    label: sido.region,
  }));
  const sigunguOptions = (sigunguList ?? []).map((sigungu) => ({
    value: sigungu.code,
    label: sigungu.region,
  }));
  const emdOptions = (emdList ?? [])
    .filter((emd) => emd.region !== '전체')
    .map((emd) => ({
      value: emd.code,
      label: emd.region,
    }));

  const ChangeStatusValue = (status: string) => {
    const newValue = BidStatusList.find((item) => item.label === status)?.value;
    return newValue ?? '';
  };

  const getList = async (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
    filters: FilterType,
  ) => {
    try {
      if (!isLogin()) return;
      const renderCaseNumber = () => {
        if (filters.type === 'a') {
          if (filters.year || filters.caseNumber) {
            return filters.year + '타경' + filters.caseNumber;
          } else {
            return '';
          }
        } else {
          if (filters.caseNumber) return filters.caseNumber;
          return '';
        }
      };

      setLoading(true);
      const res = await LoanInfoService.list(
        filters.type, // 경매  혹은 공매
        filters.regionOrCourt, //  법원 혹은 지역
        filters.court,
        filters.region
          .map((item) => `${item.sido} ${item.sigungu} ${item.emd}`)
          .join(','),
        '', // 세부 주소 혹은 건물명
        renderCaseNumber(), // 사건번호
        '', // 키워드
        filters.itemStatus.join(',') === ''
          ? filters.multiItemStatus.join(',')
          : filters.itemStatus.join(','),
        Number(filters.appraisalPrice.min),
        Number(filters.appraisalPrice.max),
        Number(filters.minPrice.min),
        Number(filters.minPrice.max),
        Number(filters.buildingArea.min),
        Number(filters.buildingArea.max),
        Number(filters.landArea.min),
        Number(filters.landArea.max),
        filters.saleDate.start,
        filters.saleDate.end,
        filters.approvalDate.start,
        filters.approvalDate.end,
        ChangeStatusValue(filters.bidStatus),
        filters.progressStatus,
        filters.specialConditionViewOption,
        filters.specialItemCondition.join(',') === ''
          ? filters.multiSpecialItemCondition.join(',')
          : filters.specialItemCondition.join(','),
        filters.useArea.join(',') === ''
          ? filters.multiUseArea.join(',')
          : filters.useArea.join(','),
        '',
        '',
        '',
        sort.value,
        limit,
        offset,
      );
      setData(res.data.list);
      setTotal(res.data.totalNumber);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (options) {
      if (parsedFilters.region && parsedFilters.region.length > 0) {
        const selectedSido =
          sidoOptions.find(
            (option) => option.label === parsedFilters.region[0]?.sido,
          ) || null;

        if (selectedSido) {
          getRegion(selectedSido.value)
            .then((res) => {
              if (res) {
                const selectedSigungu = res.find(
                  (region) =>
                    region.region === parsedFilters.region[0]?.sigungu,
                );

                if (selectedSigungu) {
                  setSigungu(selectedSigungu.code);
                }

                setSigunguList(res);
              } else {
                console.error('No data returned from getRegion');
              }
            })
            .catch((error) => {
              console.error('Error fetching regions:', error);
            });
        }
      }
    }
  }, []);

  useEffect(() => {
    if (options) {
      setFilters(parsedFilters);
      getList(0, sort, parsedFilters);
    } else {
      getList(0, sort, filters);
    }
  }, []);

  useEffect(() => {
    if (offset === 0 && data.length === 0) return;
    getList(offset, sort, filters);
  }, [offset]);

  useEffect(() => {
    if (data.length === 0) return;
    setOffset(0);
    getList(0, sort, filters);
  }, [sort]);

  const renderRegionOrCourt = () => {
    if (filters.regionOrCourt === 'r') {
      return (
        <s.FilterRow>
          <s.FilterRowContent>
            <div style={{ flex: 1 }}>
              <Select
                options={sidoOptions}
                value={
                  sidoOptions.find(
                    (option) => option.label === filters.region[0]?.sido,
                  ) || null
                }
                styles={customStyles}
                placeholder="시/도"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSido(selectedOption.value);
                    setSigungu('');
                    setEmd('');
                    setFilters({
                      ...filters,
                      region: [
                        { sido: selectedOption.label, sigungu: '', emd: '' },
                      ],
                    });
                  }
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Select
                options={sigunguOptions}
                value={
                  sigunguOptions.find(
                    (option) => option.label === filters.region[0]?.sigungu,
                  ) || null
                }
                styles={customStyles}
                placeholder="시/군/구"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSigungu(selectedOption.value);
                    setEmd('');
                    setFilters({
                      ...filters,
                      region: [
                        {
                          sido: filters.region[0]?.sido,
                          sigungu: selectedOption.label,
                          emd: '',
                        },
                      ],
                    });
                  }
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Select
                options={emdOptions}
                value={
                  emdOptions.find(
                    (option) => option.label === filters.region[0]?.emd,
                  ) || null
                }
                styles={{
                  ...customStyles,
                  control: (provided: any) => ({
                    ...customStyles.control(provided),
                  }),
                }}
                placeholder="읍/면/동"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setEmd(selectedOption.value);
                    setFilters({
                      ...filters,
                      region: [
                        {
                          sido: filters.region[0].sido,
                          sigungu: filters.region[0].sigungu,
                          emd: selectedOption.label,
                        },
                      ],
                    });
                  }
                }}
              />
            </div>
          </s.FilterRowContent>
        </s.FilterRow>
      );
    } else {
      return (
        <s.FilterRow>
          <Select
            options={CourtList}
            styles={{
              ...customStyles,
              control: (provided: any) => ({
                ...customStyles.control(provided),
              }),
            }}
            value={
              filters.court === ''
                ? null
                : {
                    label: filters.court,
                    value: filters.court,
                  }
            }
            placeholder="법원 선택"
            onChange={(selectedOption) => {
              if (selectedOption) {
                setFilters({ ...filters, court: selectedOption.value });
              }
            }}
          />
        </s.FilterRow>
      );
    }
  };
  const prevFiltersRef = useRef(filters);

  const isOnlyProgressStatusChangedToAll = () => {
    const prev = prevFiltersRef.current;

    if (filters.progressStatus !== '전체') return false;
    const { progressStatus: _, region, ...rest } = filters;
    const { progressStatus: __, region: prevRegion, ...prevRest } = prev;

    const same = JSON.stringify(rest) === JSON.stringify(prevRest);
    const isRegionChange =
      region.length === 0 ||
      (region.length === 1 &&
        region[0].sido === '' &&
        region[0].sigungu === '' &&
        region[0].emd === '');

    return same && isRegionChange;
  };

  const handleReSet = () => {
    setFilters({
      type: 'a',
      regionOrCourt: 'r',
      region: [] as Region[],
      court: '',
      year: '',
      caseNumber: '',
      itemStatus: [],
      multiItemStatus: [],
      appraisalPrice: { min: '', max: '' },
      minPrice: { min: '', max: '' },
      saleDate: { start: '', end: '' },
      approvalDate: { start: '', end: '' },
      buildingArea: { min: '', max: '' },
      landArea: { min: '', max: '' },
      bidStatus: '',
      progressStatus: '진행',
      useArea: [],
      multiUseArea: [],
      specialConditionViewOption: 'o',
      specialItemCondition: [],
      multiSpecialItemCondition: [],
      holdingCompany: [],
      multiHoldingCompany: [],
    });
  };
  return (
    <s.Container>
      <s.EasyFilterBox>
        <s.FilterInner>
          <s.FilterOptionBox style={{ gap: '8px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
              <s.FilterRow>
                <s.FilterLabel>물건분류</s.FilterLabel>
                <s.TabButtonBox>
                  <s.TabButton
                    isActive={filters.type === 'a'}
                    onClick={() => {
                      setFilters({ ...filters, type: 'a' });
                    }}
                  >
                    경매
                  </s.TabButton>
                  <s.TabButton
                    isActive={filters.type === 'p'}
                    onClick={() => {
                      setFilters({ ...filters, type: 'p', regionOrCourt: 'r' });
                    }}
                  >
                    공매
                  </s.TabButton>
                </s.TabButtonBox>
              </s.FilterRow>
              <s.FilterRow>
                <s.FilterLabel>지역/법원</s.FilterLabel>
                <s.TabButtonBox>
                  <s.TabButton
                    isActive={filters.regionOrCourt === 'r'}
                    disabled={filters.type === 'p'}
                    onClick={() => {
                      setFilters({ ...filters, regionOrCourt: 'r' });
                    }}
                    style={{
                      border:
                        filters.type === 'p'
                          ? '1px solid rgba(55, 56, 60, 0.16)'
                          : '',
                      color:
                        filters.type === 'p' ? 'rgba(55, 56, 60, 0.16)' : '',
                    }}
                  >
                    지역
                  </s.TabButton>
                  <s.TabButton
                    isActive={filters.regionOrCourt === 'c'}
                    disabled={filters.type === 'p'}
                    onClick={() => {
                      setFilters({ ...filters, regionOrCourt: 'c' });
                    }}
                    style={{
                      color:
                        filters.type === 'p' ? 'rgba(55, 56, 60, 0.16)' : '',
                    }}
                  >
                    법원
                  </s.TabButton>
                </s.TabButtonBox>
              </s.FilterRow>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '8px',
                width: '100%',
              }}
            >
              <div style={{ width: '100px' }}>
                <s.NumberInput
                  type="number"
                  pattern="[0-9]*"
                  placeholder="연도"
                  value={filters.year || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 4) {
                      setFilters({
                        ...filters,
                        year: value,
                      });
                    }
                  }}
                />
              </div>
              <s.Text>타경</s.Text>
              <div style={{ flex: 1 }}>
                <s.NumberInput
                  type="number"
                  pattern="[0-9]*"
                  placeholder="사건번호"
                  value={filters.caseNumber || ''}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      caseNumber: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            {renderRegionOrCourt()}
            <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
              <div style={{ flex: 1 }}>
                <Select
                  options={
                    filters.type === 'p' ? PTypeItemStatusList : ItemStatusList
                  }
                  styles={{
                    ...customStyles,
                    control: (provided: any) => ({
                      ...customStyles.control(provided),
                    }),
                  }}
                  placeholder="물건종류"
                  value={
                    filters.itemStatus.length > 0
                      ? {
                          label: filters.itemStatus[0],
                          value: filters.itemStatus[0],
                        }
                      : null
                  }
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setFilters({
                        ...filters,
                        multiItemStatus: [],
                        itemStatus: [selectedOption.label],
                      });
                    }
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Select
                  options={
                    filters.type === 'p'
                      ? PTypeProgressStatusList
                      : ProgressStatusList
                  }
                  styles={{
                    ...customStyles,
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                  }}
                  menuPortalTarget={document.body}
                  placeholder="진행단계"
                  value={
                    filters.progressStatus === ''
                      ? null
                      : {
                          label: filters.progressStatus,
                          value: filters.progressStatus,
                        }
                  }
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setFilters({
                        ...filters,
                        progressStatus: selectedOption.label,
                      });
                    }
                  }}
                />
              </div>
            </div>
          </s.FilterOptionBox>
          <s.ButtonBox>
            <s.ResetButton onClick={handleReSet}>
              <img src="/assets/images/icon/reset.svg" alt="" />
              <span>초기화</span>
            </s.ResetButton>
            <s.ApplyButton
              onClick={() => {
                if (!isLogin()) {
                  modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
                  return;
                }
                if (isOnlyProgressStatusChangedToAll()) {
                  window.alert(
                    `진행단계 '전체'를 선택할 경우, 추가 조건 입력이 필요합니다.\n검색 조건을 추가해주세요.`,
                  );
                  return;
                }

                if (page === 'main') {
                  navigate(
                    `/search?type=e&itemType=${filters.type}&regionOrCourt=${filters.regionOrCourt}&options=${JSON.stringify(filters)}`,
                  );
                } else {
                  getList(offset, sort, filters);
                }
              }}
            >
              검색
            </s.ApplyButton>
          </s.ButtonBox>
        </s.FilterInner>
      </s.EasyFilterBox>
      {page === 'search' && (
        <>
          <List
            data={data}
            totalCount={total}
            sort={sort}
            setSort={setSort}
            offset={offset}
            setOffset={setOffset}
            filters={filters}
            limit={limit}
            loading={loading}
            page="search"
            setSelectedIdx={setSelectedIdx}
            setShowLikeModal={setShowLikeModal}
            setMode={setMode}
            setSelectedItem={setSelectedItem}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
            getList={getList}
          />
          <Footer />
          {showLikeModal && (
            <AddInterestItemModal
              setShowLikeModal={setShowLikeModal}
              selectedIdx={selectedIdx}
              mode={mode}
              selectedItem={selectedItem}
              getList={getList}
              offset={offset}
              sort={sort}
              filters={filters}
              setActiveItem={setActiveItem}
            />
          )}
        </>
      )}
    </s.Container>
  );
};

export default EasyFilter;
